// extracted by mini-css-extract-plugin
module.exports = {"dropdown-focused":"styles-module__dropdown-focused___3g_Zp","dropdown":"styles-module__dropdown___3K-Aa"};